<div class="flex max-h-full min-h-0 w-full flex-col">
  <!-- header -->
  <div class="flex items-start gap-3 px-6 pb-2 pt-6">
    <mat-icon [class]="data.iconClass || 'text-amber-500'" fontSet="material-icons-outlined">
      {{ data.icon || 'warning' }}
    </mat-icon>
    <div>
      <h2 class="text-xl font-bold">{{ data.title }}</h2>
      <p class="text-secondary mt-1 text-base leading-relaxed" [innerHTML]="data.message"></p>
    </div>
  </div>

  <!-- lista de artículos afectados (opcional) -->
  @if (data.affectedItems?.length) {
  <div class="min-h-0 flex-1 overflow-auto px-6 py-4">
    <div class="flex items-center gap-2">
      <mat-icon class="text-red-500 icon-size-5" fontSet="material-icons-outlined">delete_sweep</mat-icon>
      <span class="font-semibold">{{ 'DOCUMENT_GENERATE.CONFIG_CHANGE_MODAL.ITEMS_TO_REMOVE' | t: { count: data.affectedItems.length } }}</span>
    </div>
    @if (data.affectedNote) {
    <p class="text-secondary mb-3 mt-1 text-sm">{{ data.affectedNote }}</p>
    }
    <div class="mt-2 overflow-x-auto rounded-xl border">
      <table class="w-full min-w-[420px] border-collapse text-base">
        <thead class="sticky top-0 bg-gray-50 dark:bg-gray-800">
          <tr class="text-secondary text-left">
            <th class="px-4 py-2 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.PRODUCT' | t }}</th>
            <th class="px-4 py-2 text-center font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.QUANTITY' | t }}</th>
          </tr>
        </thead>
        <tbody>
          @for (item of data.affectedItems; track item.lineId) {
          <tr class="border-t">
            <td class="px-4 py-2">
              <div class="flex flex-col">
                <span class="text-secondary text-xs font-semibold">{{ item.code }}</span>
                <span class="uppercase">{{ item.name }}</span>
              </div>
            </td>
            <td class="px-4 py-2 text-center">{{ item.quantity }}</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  }

  <!-- footer -->
  <div class="flex justify-end gap-3 border-t bg-gray-50 px-6 py-4 dark:bg-transparent">
    @if (data.cancelText) {
    <button mat-stroked-button type="button" (click)="cancel()">{{ data.cancelText }}</button>
    }
    <button mat-flat-button color="primary" type="button" (click)="confirm()">
      {{ data.confirmText || ('GENERAL.ACCEPT' | t) }}
    </button>
  </div>
</div>
